import { defaultStatus } from '../defaultState/defaultState';
import {
  ADD_ATTENDER_FAILURE,
  ADD_ATTENDER_REQUEST,
  ADD_ATTENDER_SUCCESS,
  DELETE_ATTENDER_FAILURE,
  DELETE_ATTENDER_REQUEST,
  DELETE_ATTENDER_SUCCESS,
  FETCH_ATTENDER_FAILURE,
  FETCH_ATTENDER_REQUEST,
  FETCH_ATTENDER_SUCCESS,
  FETCH_LIST_ATTENDER_FAILURE,
  FETCH_LIST_ATTENDER_REQUEST,
  FETCH_LIST_ATTENDER_SUCCESS,
  HISTORY_ATTENDER_FAILURE,
  HISTORY_ATTENDER_REQUEST,
  HISTORY_ATTENDER_SUCCESS,
  RESET_CURRENT_ATTENDER,
  UPDATE_ATTENDER_FAILURE,
  UPDATE_ATTENDER_REQUEST,
  UPDATE_ATTENDER_SUCCESS
} from './attenderType';

const initialState = {
  addAttenders: { ...defaultStatus },
  deleteAttender: { ...defaultStatus },
  fetchListAttender: { ...defaultStatus },
  fetchAttender: { ...defaultStatus },
  updateAttender: { ...defaultStatus },
  historyAttender: { ...defaultStatus }
}

const attenderReducer = (state = initialState, action) => {
  const { type, payload } = action || {};

  switch (type) {
    case FETCH_LIST_ATTENDER_REQUEST:
      return {
        ...state,
        fetchListAttender: {
          ...state.fetchListAttender,
          inProgress: true,
          error: null
        }
      }
    case FETCH_LIST_ATTENDER_SUCCESS:
      return {
        ...state,
        fetchListAttender: {
          ...state.fetchListAttender,
          inProgress: false,
          success: true,
          data: payload?.attender
        },
      }
    case FETCH_LIST_ATTENDER_FAILURE:
      return {
        ...state,
        fetchListAttender: {
          ...state.fetchListAttender,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }
    case HISTORY_ATTENDER_REQUEST:
      return {
        ...state,
        historyAttender: {
          ...state.fetchListAttender,
          inProgress: true,
          error: null
        }
      }
    case HISTORY_ATTENDER_SUCCESS:
      return {
        ...state,
        historyAttender: {
          ...state.fetchListAttender,
          inProgress: false,
          success: true,
          data: payload?.attender
        },
      }
    case HISTORY_ATTENDER_FAILURE:
      return {
        ...state,
        historyAttender: {
          ...state.fetchListAttender,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }

    case FETCH_ATTENDER_REQUEST:
      return {
        ...state,
        fetchAttender: { ...state.fetchAttender, inProgress: true, error: null }
      }
    case FETCH_ATTENDER_SUCCESS:
      return {
        ...state,
        fetchAttender: {
          ...state.fetchAttender,
          inProgress: false,
          success: true,
          data: payload?.attender,
        },
      }
    case FETCH_ATTENDER_FAILURE:
      return {
        ...state,
        fetchAttender: {
          ...state.fetchAttender,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }

    case ADD_ATTENDER_REQUEST:
      return {
        ...state,
        addAttenders: {
          ...state.addAttenders,
          inProgress: true,
          success: false,
          error: null,
          errorMessage: null
        }
      };
    case ADD_ATTENDER_SUCCESS:
      return {
        ...state,
        addAttenders: {
          ...state.addAttenders,
          inProgress: false,
          success: true,
          data: payload?.attenders
        },
      };
    case ADD_ATTENDER_FAILURE:
      return {
        ...state,
        addAttenders: {
          ...state.addAttenders,
          inProgress: false,
          success: false,
          error: true,
          errorMessage: payload?.error || null,
          ...payload
        }
      };

    case UPDATE_ATTENDER_REQUEST:
      return {
        ...state,
        updateAttender: { ...state.updateAttender, inProgress: true, error: null }
      }
    case UPDATE_ATTENDER_SUCCESS: {
      return {
        ...state,
        updateAttender: {
          ...state.updateAttender,
          inProgress: false,
          success: true,
          data: payload?.attender
        },
      }
    }
    case UPDATE_ATTENDER_FAILURE:
      return {
        ...state,
        updateAttender: {
          ...state.updateAttender,
          inProgress: false,
          success: false,
          error: true,
          errorMessage: payload?.errorMessage || null,
          ...payload
        }
      }

    case DELETE_ATTENDER_REQUEST:
      return {
        ...state,
        deleteAttender: { ...state.deleteAttender, inProgress: true, error: null }
      }
    case DELETE_ATTENDER_SUCCESS:
      return {
        ...state,
        deleteAttender: {
          ...state.deleteAttender,
          inProgress: false,
          success: true
        },
        attender: {
          ...state.attender,
          data: state.attender.data.filter(
            attender => attender.id !== payload.attenderId
          )
        },
        currentAttender:
          state.currentAttender.data?.id === payload.attenderId
            ? { ...defaultStatus, data: null }
            : state.currentAttender
      }
    case DELETE_ATTENDER_FAILURE:
      return {
        ...state,
        deleteAttender: {
          ...state.deleteAttender,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }

    case RESET_CURRENT_ATTENDER:
      return { ...state,addAttenders:{defaultStatus} }

    default:
      return state
  }
}

export default attenderReducer